import RichTextSection from './rich-text-section';

export default RichTextSection;
export {RichTextSection};